"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementPosition = function (element) {
    var _a = element.getBoundingClientRect(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
    var scrollX = window.scrollX, scrollY = window.scrollY;
    return {
        top: top + scrollY,
        left: left + scrollX,
        width: width,
        height: height
    };
};
exports.isDefaultTooltipsInViewport = function (targetRect, tooltipElement) {
    var _a = tooltipElement.getBoundingClientRect(), width = _a.width, height = _a.height;
    var tooltipDefaultTop = targetRect.top - height - window.scrollY;
    var tooltipDefaultLeft = targetRect.left - width + 31 + targetRect.width / 2 - window.scrollX;
    return {
        xAxis: tooltipDefaultLeft >= 0 &&
            tooltipDefaultLeft + width <= (window.innerWidth || document.documentElement.clientWidth),
        yAxis: tooltipDefaultTop >= 0 &&
            tooltipDefaultTop + height <= (window.innerHeight || document.documentElement.clientHeight)
    };
};
//# sourceMappingURL=utils.js.map